const header = document.querySelector('[data-site-header]');
const skipLink = document.querySelector('.skip-link[href="#content"]');
const main = document.querySelector('#content');

const updateHeaderState = () => {
  if (!header) {
    return;
  }

  header.classList.toggle('is-scrolled', window.scrollY > 4);
};

if (header) {
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
}

if (skipLink && main) {
  skipLink.addEventListener('click', () => {
    window.requestAnimationFrame(() => {
      main.focus({ preventScroll: true });
    });
  });
}
